__turbopack_context__.v({
  "newWrapperExtraLarge": "HIedxa_newWrapperExtraLarge",
  "wrapper": "HIedxa_wrapper",
  "wrapperExtraLarge": "HIedxa_wrapperExtraLarge",
  "wrapperExtraSmall": "HIedxa_wrapperExtraSmall",
  "wrapperLarge": "HIedxa_wrapperLarge",
  "wrapperNoPadding": "HIedxa_wrapperNoPadding",
  "wrapperSmall": "HIedxa_wrapperSmall",
});
